module.exports = __webpack_public_path__ + "static/media/fresh-veggie.818e1301.jpg";